import { scrollToFormAndSelectProduct } from './form-cta.js';

document.addEventListener('tabbed-gallery:cta', function (event) {
    scrollToFormAndSelectProduct(event.detail ?? {});
});

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tabbed-gallery]').forEach(function (root) {
        const pills = Array.from(root.querySelectorAll('[role="tab"]'));
        const layers = root.querySelectorAll(
            '.tabbed-gallery__layer, .tabbed-gallery__info-layer',
        );
        const mobileSwiperEl = root.querySelector('[data-tabbed-gallery-swiper]');
        const desktopQuery = window.matchMedia('(min-width: 1024px)');

        let activeIndex = Number.parseInt(root.dataset.activeTab ?? '0', 10);
        let isDesktop = desktopQuery.matches;
        let swiper = null;
        let swiperCanInitialize = false;
        let resizeTimeout = null;

        if (
            !Number.isInteger(activeIndex) ||
            !pills.some(
                (pill) => Number.parseInt(pill.dataset.tabIndex ?? '', 10) === activeIndex,
            )
        ) {
            activeIndex = 0;
        }

        function destroySwiper() {
            if (!swiper) {
                return;
            }

            swiper.destroy(true, true);
            swiper = null;
        }

        function syncSwiper() {
            if (isDesktop || !swiperCanInitialize || !window._swiper || !mobileSwiperEl) {
                destroySwiper();

                return;
            }

            if (swiper) {
                return;
            }

            const slideCount = mobileSwiperEl.querySelectorAll('.swiper-slide').length;
            const initialSlide = Math.max(0, slideCount - 1);

            swiper = new window._swiper(mobileSwiperEl, {
                autoHeight: true,
                speed: 600,
                modules: [
                    window._swiperEffectCards,
                    window._swiperAutoplay,
                ],
                autoplay: {
                    delay: 2400,
                    disableOnInteraction: true,
                },
                centeredSlides: true,
                effect: 'cards',
                // initialSlide,
                direction: 'vertical',
                cardsEffect: {
                    perSlideOffset: 12,
                    perSlideRotate: 0,
                    rotate: 0,
                    // slideShadows: true,
                },

                watchOverflow: false,
            });
        }

        function setActive(index) {
            const nextIndex = Number.parseInt(index, 10);

            if (
                !Number.isInteger(nextIndex) ||
                !pills.some(
                    (pill) =>
                        Number.parseInt(pill.dataset.tabIndex ?? '', 10) ===
                        nextIndex,
                )
            ) {
                return;
            }

            activeIndex = nextIndex;
            root.dataset.activeTab = String(activeIndex);

            pills.forEach(function (pill) {
                const isActive =
                    Number.parseInt(pill.dataset.tabIndex ?? '', 10) === activeIndex;

                pill.setAttribute('aria-selected', isActive ? 'true' : 'false');
                pill.tabIndex = isActive ? 0 : -1;
                pill.classList.toggle('is-active', isActive);
            });

            layers.forEach(function (layer) {
                const isActive =
                    Number.parseInt(layer.dataset.tabIndex ?? '', 10) === activeIndex;

                layer.classList.toggle('is-active', isActive);
                layer.classList.toggle('opacity-100', isActive);
                layer.classList.toggle('opacity-0', !isActive);
                layer.classList.toggle('z-[1]', isActive);
                layer.classList.toggle('z-0', !isActive);
                layer.classList.toggle('pointer-events-auto', isActive);
                layer.classList.toggle('pointer-events-none', !isActive);
            });

            syncSwiper();
        }

        pills.forEach(function (pill, pillPosition) {
            pill.addEventListener('click', function () {
                setActive(pill.dataset.tabIndex);
            });

            pill.addEventListener('keydown', function (event) {
                let nextPosition;

                if (event.key === 'ArrowRight') {
                    nextPosition = (pillPosition + 1) % pills.length;
                } else if (event.key === 'ArrowLeft') {
                    nextPosition = (pillPosition - 1 + pills.length) % pills.length;
                } else if (event.key === 'Home') {
                    nextPosition = 0;
                } else if (event.key === 'End') {
                    nextPosition = pills.length - 1;
                } else {
                    return;
                }

                event.preventDefault();
                setActive(pills[nextPosition].dataset.tabIndex);
                pills[nextPosition].focus();
            });
        });

        root.addEventListener('click', function (event) {
            const cta = event.target.closest('[data-tabbed-gallery-cta]');

            if (!cta || !root.contains(cta)) {
                return;
            }

            document.dispatchEvent(
                new CustomEvent('tabbed-gallery:cta', {
                    detail: {
                        package: cta.dataset.package ?? null,
                        packageDetails: cta.dataset.packageDetails ?? null,
                        formSectionId: root.dataset.formSectionId ?? null,
                    },
                }),
            );
        });

        window.whenSwiperVisible(root, function () {
            swiperCanInitialize = true;
            syncSwiper();
            setActive(activeIndex);
        });

        window.addEventListener('resize', function () {
            window.clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(function () {
                const nextIsDesktop = desktopQuery.matches;

                if (nextIsDesktop === isDesktop) {
                    return;
                }

                isDesktop = nextIsDesktop;
                setActive(activeIndex);
            }, 150);
        });

        setActive(activeIndex);
    });
});
